import CRUDService from "../services/base/CRUDService";

export default class BizLocationService extends CRUDService {

  getBaseURL() {
    return "ton/v1/biz-locations/";
  }

}



// WEBPACK FOOTER //
// ./src/bizLocation/BizLocationService.js